import React, { FC, Suspense } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import routePath from '../../../router/routePath'
import { View } from '../../../components'
import { QuestionErrorHandler as ErrorHandler } from '../ErrorHandler'
import { QuestionViewDataLoader } from './QuestionViewDataLoader'
import { QuestionDetailView } from './QuestionDetailView'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

export const QuestionView: FC = () => {
  const { t } = useTranslation(['common', 'question', 'titles'])
  const { currentContractId } = useCurrentContract()

  const backPath = routePath.contactInfo.replace(
    ':contractId',
    currentContractId
  )

  const backText = t('titles:contactInformation')

  return (
    <TitleController title={t('question:headings.question')}>
      <View>
        <View.Header>
          <View.HeaderLink to={backPath}>{backText}</View.HeaderLink>
          <View.HeaderTitle>
            {t('question:headings.housingQuestion')}
          </View.HeaderTitle>
        </View.Header>
        <View.Sidebar />
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ErrorHandler>
              <QuestionViewDataLoader>
                {({ user, questionNotice }) => (
                  <QuestionDetailView
                    existingNotice={questionNotice}
                    user={user}
                  />
                )}
              </QuestionViewDataLoader>
            </ErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
